import {useMediaQuery} from '@mui/material'
import Drawer from '@mui/material/Drawer'
import {useEffect, useRef} from 'react'
import {useDispatch} from 'react-redux'
import {useParams} from 'react-router'
import {GetStickers, GetVirtualGifts, setMockDialog} from 'entities/messages'
import {Gallery} from 'features/gallery'
import {Sidebar} from 'features/sidebar'
import {BottomMenu} from 'widgets/bottomMenu'
import {HeaderDesktop, HeaderMobile} from 'widgets/header'
import styles from './styles.module.scss'
import {Chat} from './ui/chat'
import {Dialogs} from './ui/dialogs'
import {Profile} from './ui/profile'
import {SearchDialogs} from './ui/searchDialogs'

export const MessagesPage = () => {
  const dispatch = useDispatch()
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)
  GetStickers(dispatch)
  GetVirtualGifts(dispatch)

  useEffect(() => {
    dispatch(setMockDialog(undefined))
  }, [])

  return (
    <>
      {is768p ? <MobileVersion /> : <DesktopVersion />}
      <Gallery isHideLike />
    </>
  )
}

const DesktopVersion = () => {
  const is1280p = useMediaQuery(`(max-width: ${styles.is1280p})`)

  return (
    <div className={styles.root}>
      <HeaderDesktop />

      <div className={`${styles.wrapper} ${styles.customScroll}`}>
        <div className={styles.workArea}>
          <Sidebar className={styles.sidebar} />

          <div className={styles.massages}>
            <div className={styles.dialogs}>
              <SearchDialogs />
              <Dialogs />
            </div>
            <Chat />
            {!is1280p ? <Profile /> : null}
          </div>
        </div>
      </div>
    </div>
  )
}

const MobileVersion = () => {
  const {id} = useParams()
  const ref = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <div className={styles.root}>
        <HeaderMobile wrapperRef={ref} />
        <div className={styles.dialogs}>
          <Dialogs ref={ref} />
        </div>
        <BottomMenu />
      </div>

      <Drawer open={Boolean(id)} anchor='right'><Chat /></Drawer>
    </>
  )
}